import { combineReducers } from 'redux'
import store from './store'

const rootReducer = combineReducers({
	store
})

export default rootReducer
